import { installUiBus } from '@amusnet/amusnet-common'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import '@amusnet/react-ui/dist/index.css'
import App from './App.tsx'

// Normally installed by amusnet-library's GameInit, which runs before game-ui.
// This covers engines on an older amusnet-library that never install it.
installUiBus()

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>
)
